import { ShopModeState, ShopModeActionTypes, SET_SHOP_MODE, ShopMode } from '../types/shopMode.types';

const STORAGE_KEY = 'shopMode';

// Carica da localStorage
const loadModeFromStorage = (): ShopMode | null => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === ShopMode.LocalDelivery || saved === ShopMode.DirectSale) {
      return saved;
    }
  } catch (error) {
    console.error('Error loading shop mode from localStorage:', error);
  }
  return null;
};

// Salva in localStorage
const saveModeToStorage = (mode: ShopMode): void => {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch (error) {
    console.error('Error saving shop mode to localStorage:', error);
  }
};

const initialState: ShopModeState = {
  mode: loadModeFromStorage(),
};

const shopModeReducer = (state = initialState, action: ShopModeActionTypes): ShopModeState => {
  switch (action.type) {
    case SET_SHOP_MODE:
      saveModeToStorage(action.payload);
      return {
        ...state,
        mode: action.payload,
      };
    default:
      return state;
  }
};

export default shopModeReducer;
